export class InvoiceModel {
  public id: string;
  public amount: number;
  public currencyCode: string;
  public processorName: string;
  public status: string;
  public date: string;
}
